import { Cell } from 'utils/data'

export interface MetricConfig {
    name: string
    ytdIndex: number
    bpIndex?: number
    bpValue?: string
    daysIndex?: number
}

export const EXTERNAL_METRICS_PERCENT: MetricConfig[] = [
    { name: 'detained apprehensions', ytdIndex: 1, bpIndex: 2 },
    { name: 'external app productivity', ytdIndex: 5, bpValue: '—' },
    { name: 'average app $', ytdIndex: 14, bpValue: '—' },
    { name: 'NPI rate', ytdIndex: 15, bpValue: '—' },
    { name: 'PMR', ytdIndex: 10, bpIndex: 11 },
    { name: 'KTR', ytdIndex: 6, bpIndex: 7 },
]

export const EXTERNAL_METRICS_DOLLARS: MetricConfig[] = [
    { name: 'detained apprehensions', ytdIndex: 3, bpIndex: 4 },
    { name: 'external app productivity', ytdIndex: 5, bpValue: '—' },
    { name: 'average app $', ytdIndex: 14, bpValue: '—' },
    { name: 'NPI rate', ytdIndex: 15, bpValue: '—' },
    { name: 'PMR', ytdIndex: 12, bpIndex: 13 },
    { name: 'KTR', ytdIndex: 8, bpIndex: 9 },
]

export const INTERNAL_METRICS_PERCENT: MetricConfig[] = [
    {
        name: 'merchandise investigations',
        ytdIndex: 2,
        bpIndex: 3,
        daysIndex: 1,
    },
    {
        name: 'POS/ other investigations',
        ytdIndex: 7,
        bpIndex: 8,
        daysIndex: 6,
    },
]

export const INTERNAL_METRICS_DOLLARS: MetricConfig[] = [
    {
        name: 'merchandise investigations',
        ytdIndex: 4,
        bpIndex: 5,
        daysIndex: 1,
    },
    {
        name: 'POS/ other investigations',
        ytdIndex: 10,
        bpIndex: 9,
        daysIndex: 6,
    },
]

export const EXTERNAL_HEADINGS: Cell[] = [
    { value: ' ', raw: ' ' },
    { value: 'ty', raw: 'ty' },
    { value: 'b/(p) to ly', raw: 'b/(p) to ly' },
]

export const INTERNAL_HEADINGS: Cell[] = [
    { value: ' ', raw: ' ' },
    { value: 'ty', raw: 'ty' },
    { value: 'b/(p) to ly', raw: 'b/(p) to ly' },
    { value: 'days to close (avg)', raw: 'days to close (avg)' },
]
